import { Type, Static } from '@sinclair/typebox';

export enum NodeEnv {
  development = 'development',
  test = 'test',
  production = 'production',
  staging = 'staging',
}

/** */
export const AppConfigSchema = Type.Object({
  NODE_ENV: Type.Enum(NodeEnv),
  JWT_SECRET: Type.Optional(Type.String()),
  LOG_LEVEL: Type.Union([
    Type.Literal('fatal'),
    Type.Literal('error'),
    Type.Literal('warn'),
    Type.Literal('info'),
    Type.Literal('debug'),
    Type.Literal('trace'),
  ]),
  SENTRY_DSN: Type.String(),
  SENTRY_AUTH_TOKEN: Type.String(),
  API_VERSION: Type.String(),
  DB_NAME: Type.String(),
  DB_HOST: Type.String(),
  DB_PORT: Type.String(),
  DB_USERNAME: Type.String(),
  DB_PASSWORD: Type.String(),
  DB_TLS_CERT: Type.Optional(Type.String()),
  STRIPE_API_KEY: Type.String(),
  STRIPE_ENDPOINT_SECRET: Type.String(),
  STRIPE_PRICE_ID: Type.String(),
  BREVO_API_KEY: Type.String(),
  MAILER_DSN: Type.String(),
  GOOGLE_OAUTH_CLIENT_ID: Type.String(),
  GOOGLE_OAUTH_CLIENT_SECRET: Type.String(),
  MICROSOFT_OAUTH_CLIENT_ID: Type.String(),
  MICROSOFT_OAUTH_CLIENT_SECRET: Type.String(),
  REDIS_HOSTS: Type.String(),
  REDIS_PORTS: Type.String(),
  REDIS_USERNAME: Type.Optional(Type.String()),
  REDIS_PASSWORD: Type.Optional(Type.String()),
  REDIS_TLS_CERT: Type.Optional(Type.String()),
  UNIPILE_API_BASE_URL: Type.String(),
  AUTH_BASE_URL: Type.String(),
  METHODS_BASE_URL: Type.String(),
  DASHBOARD_BASE_URL: Type.String(),
  HOSTED_AUTH_BASE_URL: Type.String(),
  HOSTED_AUTH_CNAME_WEBHOOK_URL: Type.Optional(Type.String()),
  UNILOGIN_BASE_URL: Type.Optional(Type.String()),
  UNILOGIN_SERVICE_TOKEN: Type.Optional(Type.String()),
  UNILOGIN_CALLBACK_URL: Type.Optional(Type.String()),
  UNILOGIN_CALLBACK_SIGNING_SECRET: Type.Optional(Type.String()),
  UNILOGIN_EXTENSION_BRIDGE_URL: Type.Optional(Type.String()),
  UNILOGIN_EXTENSION_STORE_URL: Type.Optional(Type.String()),
  UNILOGIN_FIREFOX_EXTENSION_STORE_URL: Type.Optional(Type.String()),
  UNILOGIN_EDGE_EXTENSION_DOWNLOAD_URL: Type.Optional(Type.String()),
  UNILOGIN_SAFARI_EXTENSION_DOWNLOAD_URL: Type.Optional(Type.String()),
  TRACKING_CNAME_WEBHOOK_URL: Type.Optional(Type.String()),
  CNAME_WEBHOOK_USERNAME: Type.Optional(Type.String()),
  CNAME_WEBHOOK_PASSWORD: Type.Optional(Type.String()),
  TRACKING_BASE_URL: Type.String(),
  TRACKING_SIGNATURE_SECRET: Type.String(),
  OAUTH_REDIRECT_URI: Type.String(),
  GOOGLE_OAUTH_SCOPE: Type.String(),
  MICROSOFT_OAUTH_SCOPE: Type.String(),
  AUTHORIZATION_CACHE_TTL_MS: Type.String(),
  OAUTH_CONFIG_CACHE_TTL_MS: Type.String(),
  TELEGRAM_API_ID: Type.String(),
  TELEGRAM_API_HASH: Type.String(),
  IMAP_WORKERS: Type.String(),
  IMAP_DB_ENCRYPTION_KEY: Type.Optional(Type.String()),
  WHATSAPP_API_WS_TOKEN: Type.String(),
  MONGODB_URI: Type.String(),
  MONGODB_DB_NAME: Type.String(),
  MONGODB_LOCAL_MASTER_KEY: Type.Optional(Type.String()),
  MONGODB_DATA_ENCRYPTION_KEY: Type.Optional(Type.String()),
  MONGODB_AUTH_SOURCE: Type.Optional(Type.String()),
  MONGODB_TLS_CERT: Type.Optional(Type.String()),
  CAPSOLVER_API_KEY: Type.String(),
  TURNSTILE_SECRET_KEY: Type.String(),
  SOCIAL_AUTH_GOOGLE_OAUTH_CLIENT_ID: Type.String(),
  SOCIAL_AUTH_GOOGLE_OAUTH_CLIENT_SECRET: Type.String(),
  SOCIAL_AUTH_GITHUB_OAUTH_CLIENT_ID: Type.String(),
  SOCIAL_AUTH_GITHUB_OAUTH_CLIENT_SECRET: Type.String(),
});

export type AppConfig = Static<typeof AppConfigSchema>;
